import React, { Component } from 'react';
import SubmitButton from '../buttons/submitButton';

import SingleMan from '../icons/singleMan';
import SingleWoman from '../icons/singleWoman';

import './genderSelect.css';

class GenderSelect extends Component {

  state = {
    buttonsEnabled: true,
  }

  renderStyling(item) {
    if (this.props.selectedItems.includes(item)) {
      return {
        icon: {
          fill: '#fff',
        },
        selectButton: {
          style: {
            color: '#fff',
            background: '#6A93A8',
          },
        },
      }
    } else {
      return {
        icon: {
          fill: 'rgba(0,0,0,0.3)',
        },
        selectButton: {
          style: {
            color: 'rgba(0,0,0,0.4)',
            background: '#fff',
          },
        },
      }
    }
  }

  disableButtons(timeout) {
    this.setState({buttonsEnabled: false})

    setTimeout(() => {
      this.setState({buttonsEnabled: true})
    }, timeout)
  }

  render() {

    return(
      <div className="user-row">

        <div className="gender-select-items-wrapper">
          <div className="gender-select-items-box">


            {
              Object.keys(this.props.data).map((item) => (
                <div key={item}>
                  {
                    item === "male" &&
                      <div
                        className="gender-select-button drop-shadow"
                        style={this.renderStyling(item).selectButton.style}
                        onClick={() => this.props.setItems(item)}
                      >

                        <SingleMan
                          width="60px"
                          fill={this.renderStyling(item).icon.fill}
                          style={{paddingLeft: '15px'}}
                        />
                        {this.props.data[item]}

                      </div>
                  }

                  {
                    item === "female" &&
                      <div
                        className="gender-select-button drop-shadow"
                        style={this.renderStyling(item).selectButton.style}
                        onClick={() => this.props.setItems(item)}
                      >

                        <SingleWoman
                          width="60px"
                          fill={this.renderStyling(item).icon.fill}
                          style={{paddingLeft: '15px'}}
                        />
                        {this.props.data[item]}

                      </div>
                  }
                </div>
              ))
            }
          </div>


          {this.props.selectedItems.length >= 1 && this.props.itemsSaved === false &&
            <div className="gender-select-submit-box">
              <SubmitButton
                action={() => this.props.saveItems()}
                label={this.props.buttonText}
                disableButtons={(timeout) => this.disableButtons(timeout)}
              />
            </div>
          }
        </div>

        {this.props.companyLogo.length > 0 &&
          <div className="user-avatar-company-logo">
            <img
              src={`${this.props.companyLogo}`}
              alt=""
              style={{width: '100%'}}
            />
          </div>
        }

        {this.props.companyLogo.length === 0 &&
          <div className="user-avatar">
            {this.props.companyName.charAt(0).toUpperCase()}
          </div>
        }
      </div>
    )
  }
}

export default GenderSelect;
